<template>
    <div class="render-post-failed" :style="{ fontSize: fontSize + 'px' }" ref="render-post">
        <i class="fa-regular fa-circle-exclamation"></i>
        <p>{{ textError }}</p>
    </div>
</template>

<script>
    import renderPostMixin from '../../../mixins/renderPost';

    export default {
    mixins: [renderPostMixin],
        props: {
            textError: {
                type: String,
                default: ''
            },
        },
    }
</script>

<style lang="scss" scoped>

</style>